<!--
	Copyright (c) 2021-present, Bäumer, Afonso, Meissner GmbH
	All rights reserved.
-->
<script setup>
import { onMounted, ref } from "vue";
import { useStorage } from "@vueuse/core";

const el = ref(null);
const visible = ref(false);
const brandTransitionSeen = useStorage("brand-transition-2-seen", false);
const appeared = ref(false);

onMounted(() => {
    window.setTimeout(() => {
        visible.value = true;
    }, 500);
});
const onAfterEnter = () => {
    appeared.value = true;
};

const close = () => {
    visible.value = false;
    brandTransitionSeen.value = true;
};
</script>

<template>
    <transition name="transition-element__show" @after-enter="onAfterEnter">
        <div
            v-if="visible && !brandTransitionSeen"
            class="transition-element"
            :class="{ 'transition-element--appeared': appeared }"
            ref="el"
        >
            <div class="transition-element__steps">
                <div
                    class="transition-element__step transition-element__step--one"
                >
                    <slot name="step1" />
                </div>
                <div
                    class="transition-element__step transition-element__step--two"
                >
                    <slot name="step2" />
                </div>
            </div>
            <span @click="close" class="transition-element__close"
                ><slot name="close"
            /></span>
        </div>
    </transition>
</template>
